import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import i18n from '@/utils/lang/index'
import echarts from './utils/echarts';
import '@/assets/icons/iconfont.css'
import './permission'
import zhLocale from "element-plus/es/locale/lang/zh-cn"

if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  const isResizeObserverLoopError = (text) => {
    return typeof text === 'string' && (text.includes('ResizeObserver loop') || text.includes('ResizeObserver loop limit exceeded'))
  }

  const originalConsoleError = window.console?.error
  if (typeof originalConsoleError === 'function') {
    window.console.error = (...args) => {
      const first = args && args.length ? args[0] : undefined
      const text = typeof first === 'string' ? first : first?.message
      if (isResizeObserverLoopError(text)) return
      originalConsoleError.apply(window.console, args)
    }
  }

  window.onerror = (message, _source, _lineno, _colno, error) => {
    const text = typeof message === 'string' ? message : error?.message
    if (isResizeObserverLoopError(text)) return true
    return false
  }

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason
    const text = typeof reason === 'string' ? reason : reason?.message
    if (isResizeObserverLoopError(text)) {
      event.preventDefault()
    }
  })

  window.addEventListener(
    'error',
    (event) => {
      const message = event?.message || event?.error?.message || ''
      if (isResizeObserverLoopError(message)) {
        event.preventDefault()
        event.stopImmediatePropagation()
      }
    },
    true
  )
}

const app=createApp(App)

app.use(ElementPlus,{
    locale: zhLocale
})
app.config.globalProperties.$echarts = echarts

const applyPermissionStyle = (el, value) => {
  const requiredPermissions = Array.isArray(value) ? value : [value]
  const validPermissions = requiredPermissions.filter((item) => !!item)
  if (!validPermissions.length) {
    el.style.display = ''
    return
  }
  const userPermissions = store.getters.info?.permissions || store.getters.permissions || []
  const hasPermission = validPermissions.some((item) => userPermissions.includes(item))
  el.style.display = hasPermission ? '' : 'none'
}

app.directive('perm', {
  mounted(el, binding) {
    applyPermissionStyle(el, binding.value)
  },
  updated(el, binding) {
    applyPermissionStyle(el, binding.value)
  }
})

app.use(i18n)
app.use(store).use(router).mount('#app')
